import { colors } from "@mui/material";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "'PP Neue Montreal', sans-serif",
    h1: {
      fontFamily: "'Clash Display', sans-serif",
      fontSize: "72px",
      fontWeight: 500,
      lineHeight: 1.2,
      color: "#fff",
      "@media(max-width: 1024px)": {
        fontSize: "42px",
      },
      "@media(max-width: 767px)": {
        fontSize: "32px",
      },
    },
    h2: {
      fontFamily: "'Clash Display', sans-serif",
      fontSize: "42px",
      fontWeight: 500,
      lineHeight: 1.2,
      color: "#fff",
      "@media(max-width: 1024px)": {
        fontSize: "36px",
      },
      "@media(max-width: 767px)": {
        fontSize: "30px",
      },
    },
    h3: {
      fontSize: "20px",
      color: "#fff",
      lineHeight: "1.2",
    },
    body1: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: 1.3,
      color: "#d5d2e0",
      "@media(max-width: 767px)": {
        fontSize: "14px",
      },
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Clash Display', sans-serif",
          fontSize: "16px",
          textTransform: "none",
          color: "#fff",
          "@media(max-width: 767px)": {
            fontSize: "14px",
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #4F4A62",
          borderRadius: "0px !important",
          margin: "0px 0 10px !important",
          padding: "15px 0",
          backgroundColor: "transparent",
          "& button": {
            minHeight: "auto !important",
          },
          "& p": {
            color: "#fff",
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: "0px",
          margin: "0px",
          "& .MuiAccordionSummary-expandIconWrapper": {
            color: "#fff",
          },
          "& .MuiAccordionSummary-content": {
            margin: "0px !important",
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: "20px 0 10px",
          backgroundColor: "transparent",
          "& p": {
            color: "#fff",
          },
        },
      },
    },
  },
});

export default theme;
